import { RiCheckboxCircleFill } from '@remixicon/react';

import { Icon } from '@spotify-internal/encore-web';
import { FormFieldsBox, FormTextField } from '@spotify/confidence-core-react';

import {
  useAccountDetailsContext,
  useWorkspaceNameFieldsContext,
} from './CreateAccountFormProvider';
import { isDisplayNameValid, suggestWorkspaceName } from './signupUtils';

export const WorkspaceNameFields = () => {
  const { accountDetails } = useAccountDetailsContext();
  const {
    handleDisplayNameChange,
    handleDisplayNameBlur,
    validDisplayName,
    helperText,
  } = useWorkspaceNameFieldsContext();
  const suggestedWorkspaceName = suggestWorkspaceName(
    accountDetails.adminEmail,
  );
  const workspaceNamePlaceholder = suggestedWorkspaceName
    ? `For example ${suggestedWorkspaceName}`
    : 'Your company or team name';
  const iconTrailing = isDisplayNameValid(accountDetails.displayName) ? (
    <Icon
      as={RiCheckboxCircleFill}
      size="small"
      semanticColor="textPositive"
      aria-hidden
    />
  ) : undefined;

  return (
    <FormFieldsBox>
      <FormTextField
        label="Workspace name"
        name="workspace-name"
        indicator="required"
        size="large"
        placeholder={workspaceNamePlaceholder}
        value={accountDetails.displayName}
        helperText={validDisplayName ? helperText : undefined}
        error={validDisplayName ? undefined : helperText}
        iconTrailing={iconTrailing}
        required
        onChange={event => handleDisplayNameChange(event.currentTarget.value)}
        onBlur={handleDisplayNameBlur}
       data-track-source-anchor="75cc0e1382;workspace-name-fields-form-text-field"/>
    </FormFieldsBox>
  );
};
